<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-checkbox-marked-circle-outline</v-icon
            >
            <pre><v-toolbar-title><h2>Ventas Yotico</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-tabs class="mt-4">
            <v-tab>
                <v-icon left>mdi-format-list-bulleted</v-icon>
                Ventas Yotico
            </v-tab>
            <v-tab>
                <v-icon left>mdi-history</v-icon>
                Historial
            </v-tab>
            <v-tab>
                <v-icon left>mdi-chart-line</v-icon>
                Ventas Mensuales
            </v-tab>
            <v-tab>
                <v-icon left>mdi-account-group</v-icon>
                Ventas Referidos
            </v-tab>

            <v-tab-item key="1">
                <loader :loading="isLoading"></loader>

                <v-row>
                    <v-col cols="12" md="4">
                        <FilterComponentVue
                            :headers="filter_headers"
                            :onlySearch="user.role == 11 || user.role == 14"
                            v-model="filtros_prueba"
                        ></FilterComponentVue>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-btn
                            color="primary"
                            class="mt-3"
                            @click="syncDataYotico()"
                        >
                            <v-icon color="white">mdi-sync</v-icon>
                            Sincronizar datos
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn
                            color="success"
                            class="mt-3 white--text"
                            @click="exportToExcel()"
                            :loading="isExporting"
                        >
                            <v-icon color="white" left>mdi-file-excel</v-icon>
                            Exportar a Excel
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn
                            color="primary"
                            outlined
                            class="mt-3"
                            @click="openInvoiceDialog()"
                        >
                            <v-icon color="primary">mdi-file</v-icon>
                            Generar facturas
                        </v-btn>
                    </v-col>
                </v-row>

                <v-data-table
                    id="ventas-yotico"
                    :server-items-length="totalItems"
                    dense
                    :headers="headers"
                    :items="ventas"
                    :search="filtros_prueba.search"
                    :items-per-page="15"
                    item-key="id"
                    class="elevation-1"
                    :item-class="row_classes"
                    @click:row="
                        (item) => {
                            if (user.role != 11) {
                                venta = item;
                                form_dialog = true;
                            }
                        }
                    "
                    @update:options="loadItems"
                >
                    <template v-slot:item.fecha_alta="{ item }">
                        {{ item.fecha_alta | format_date }}
                    </template>

                    <template v-slot:item.fecha_inicio_facturacion="{ item }">
                        {{ item.fecha_inicio_facturacion | format_date }}
                    </template>

                    <template v-slot:item.metodo_pago="{ item }">
                        {{ item.metodo_pago || "" }}
                    </template>

                    <template v-slot:item.importe="{ item }">
                        <v-text-field
                            v-model="item.pvp"
                            @input="item.pvp = inputPrice($event)"
                            dense
                            suffix="€"
                            @change="saveCaracteristicasVentaYotico(item)"
                        />
                    </template>
                    <template v-slot:item.importe_calculado="{ item }">
                        <v-text-field
                            v-model="item.importe_calculado"
                            @input="item.importe_calculado = inputPrice($event)"
                            dense
                            suffix="€"
                            @change="saveCaracteristicasVentaYotico(item)"
                        />
                    </template>
                    <template v-slot:item.plantilla="{ item }">
                        <v-checkbox
                            v-model="item.plantilla"
                            @change="saveCaracteristicasVentaYotico(item)"
                        />
                    </template>
                    <template v-slot:item.configurado="{ item }">
                        <v-checkbox
                            v-model="item.configurado"
                            @change="saveCaracteristicasVentaYotico(item)"
                        />
                    </template>
                    <template v-slot:item.observaciones="{ item }">
                        <v-textarea
                            v-model="item.observaciones"
                            @change="saveCaracteristicasVentaYotico(item)"
                        />
                    </template>
                </v-data-table>

                <v-dialog v-model="isInvoiceDialogVisible" max-width="500px">
                    <v-card>
                        <v-card-title class="text-h5 dialog-title">
                            Generar facturas
                        </v-card-title>
                        <v-card-text class="mt-3">
                            <v-row justify="center">
                                <v-col cols="12">
                                    <h3 class="text-center">
                                        Por favor establezca una fecha de
                                        facturación
                                    </h3>
                                    <p class="text-center">
                                        Considere que esta fecha sera la que se
                                        le asignará a las facturas generadas de
                                        todos los clientes
                                    </p>
                                </v-col>
                                <v-col cols="12">
                                    <date-select
                                        v-model="invoiceDate"
                                        outlined
                                        label="Fecha de la factura"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-center">
                            <v-btn color="success" @click="generateInvoices()"
                                >Confirmar</v-btn
                            >
                            <v-btn color="error" @click="closeInvoiceDialog"
                                >Cancelar</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-tab-item>

            <v-tab-item key="historial">
                <loader :loading="historyLoading"></loader>
                <v-card class="mt-4">
                    <v-card-title class="d-flex justify-space-between align-center">
                        <span>Historial de sincronizaciones</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-4">
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="historyDate"
                                    label="Fecha"
                                    outlined
                                    dense
                                    clearable
                                    @input="onHistoryDateChange"
                                />
                            </v-col>
                            <v-col cols="12" md="4" class="d-flex align-center">
                                <v-checkbox
                                    v-model="historyShowAll"
                                    label="Mostrar todos"
                                    hide-details
                                    @change="onHistoryShowAllChange"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="4" class="d-flex align-center justify-end">
                                <v-btn
                                    color="success"
                                    class="mt-2"
                                    :loading="isHistoryExporting"
                                    @click="exportHistory"
                                >
                                    <v-icon left>mdi-file-excel</v-icon>
                                    Exportar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="historyHeaders"
                            :items="historyItems"
                            :loading="historyLoading"
                            :options="historyOptions"
                            :server-items-length="historyTotal"
                            :items-per-page="historyOptions.itemsPerPage"
                            @update:options="onHistoryOptionsChange"
                            class="elevation-1"
                        >
                            <template v-slot:body.prepend>
                                <tr v-if="historyItems.length === 0 && !historyLoading">
                                    <td :colspan="historyHeaders.length" class="text-center">
                                        No hay registros disponibles.
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:item.synced_at="{ item }">
                                {{ formatDateTime(item.synced_at) }}
                            </template>
                            <template v-slot:item.fecha_inicio_facturacion="{ item }">
                                {{ formatDate(item.fecha_inicio_facturacion) }}
                            </template>
                            <template v-slot:item.importe_calculado="{ item }">
                                {{ formatPrice(item.importe_calculado) }} €
                            </template>
                            <template v-slot:item.calculo_detalle="{ item }">
                                <div class="calculo-desglose">
                                    <div
                                        v-if="!item.calculo_detalle || item.calculo_detalle.length === 0"
                                        class="caption grey--text text--darken-1"
                                    >
                                        Sin información
                                    </div>
                                    <div
                                        v-else
                                        v-for="(linea, idx) in item.calculo_detalle"
                                        :key="idx"
                                        class="calculo-linea"
                                    >
                                        {{ linea }}
                                    </div>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-tab-item>

            <v-tab-item key="2">
                <loader :loading="isLoadingMensuales"></loader>

                <v-row class="mt-4">
                    <v-col cols="12">
                        <v-card>
                            <v-card-title>
                                <v-icon left>mdi-chart-line</v-icon>
                                Ventas Mensuales por Año
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-select
                                            v-model="añoSeleccionado"
                                            :items="añosDisponibles"
                                            label="Seleccionar Año"
                                            @change="cargarVentasMensuales"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn
                                            color="success"
                                            @click="exportarVentasMensuales"
                                            :loading="isLoadingMensuales"
                                            class="mt-2"
                                        >
                                            <v-icon left>mdi-file-excel</v-icon>
                                            Exportar a Excel
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-icon left>mdi-table</v-icon>
                        Resumen de Ventas por Mes
                    </v-card-title>
                    <v-data-table
                        :headers="headersMensuales"
                        :items="ventasMensuales"
                        :loading="isLoadingMensuales"
                        item-key="id"
                        class="elevation-1"
                        :items-per-page="-1"
                        :search="searchMensuales"
                        hide-default-footer
                    >
                        <!-- Templates para mostrar los datos de cada mes -->
                        <template v-slot:item.mes_1="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_1 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_1 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_2="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_2 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_2 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_3="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_3 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_3 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_4="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_4 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_4 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_5="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_5 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_5 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_6="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_6 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_6 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_7="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_7 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_7 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_8="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_8 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_8 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_9="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_9 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_9 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_10="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_10 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_10 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_11="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_11 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_11 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_12="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_12 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_12 || 0 }}</span>
                        </template>

                        <template v-slot:item.total_anual="{ item }">
                            <strong v-if="item.id === 'facturacion'">{{
                                formatPrice(item.total_anual)
                            }}</strong>
                            <strong v-else>{{ item.total_anual }}</strong>
                        </template>
                        <template v-slot:body.append>
                            <tr class="font-weight-bold">
                                <td class="text-center">
                                    <strong>TOTAL FACTURACIÓN</strong>
                                </td>
                                <td
                                    v-for="index in 12"
                                    :key="index"
                                    class="text-center"
                                >
                                    <strong>{{
                                        formatPrice(totalPorMes[index] || 0)
                                    }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        formatPrice(totalGeneral)
                                    }}</strong>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>

                <!-- Tabla de Detalles por Empresa -->
                <v-card class="mt-4">
                    <v-card-title>
                        <v-icon left>mdi-format-list-bulleted</v-icon>
                        Detalles de Ventas por Empresa
                    </v-card-title>
                    <v-data-table
                        :headers="headersDetalles"
                        :items="detallesEmpresas"
                        :loading="isLoadingMensuales"
                        item-key="id"
                        class="elevation-1"
                        :items-per-page="-1"
                        :search="searchDetalles"
                        hide-default-footer
                    >
                        <!-- Template para fecha de alta -->
                        <template v-slot:item.fecha_alta="{ item }">
                            {{ item.fecha_alta | format_date }}
                        </template>

                        <!-- Templates para mostrar los datos de cada mes -->
                        <template v-slot:item.mes_1="{ item }">
                            <span>{{ formatPrice(item.mes_1 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_2="{ item }">
                            <span>{{ formatPrice(item.mes_2 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_3="{ item }">
                            <span>{{ formatPrice(item.mes_3 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_4="{ item }">
                            <span>{{ formatPrice(item.mes_4 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_5="{ item }">
                            <span>{{ formatPrice(item.mes_5 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_6="{ item }">
                            <span>{{ formatPrice(item.mes_6 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_7="{ item }">
                            <span>{{ formatPrice(item.mes_7 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_8="{ item }">
                            <span>{{ formatPrice(item.mes_8 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_9="{ item }">
                            <span>{{ formatPrice(item.mes_9 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_10="{ item }">
                            <span>{{ formatPrice(item.mes_10 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_11="{ item }">
                            <span>{{ formatPrice(item.mes_11 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_12="{ item }">
                            <span>{{ formatPrice(item.mes_12 || 0) }}</span>
                        </template>

                        <template v-slot:item.total_anual="{ item }">
                            <strong>{{ formatPrice(item.total_anual) }}</strong>
                        </template>
                        <template v-slot:body.append>
                            <tr class="font-weight-bold">
                                <td class="text-center">
                                    <strong>TOTAL</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        detallesEmpresas.reduce(
                                            (sum, emp) =>
                                                sum +
                                                (emp.num_trabajadores || 0),
                                            0
                                        )
                                    }}</strong>
                                </td>
                                <td></td>
                                <td
                                    v-for="index in 12"
                                    :key="index"
                                    class="text-center"
                                >
                                    <strong>{{
                                        formatPrice(totalPorMes[index] || 0)
                                    }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        formatPrice(totalGeneral)
                                    }}</strong>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>

            <v-tab-item key="3">
                <loader :loading="isLoadingReferidos"></loader>

                <v-row class="mt-4">
                    <v-col cols="12">
                        <v-card>
                            <v-card-title>
                                <v-icon left>mdi-account-group</v-icon>
                                Ventas por Referido por Año
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-select
                                            v-model="añoSeleccionadoReferidos"
                                            :items="añosDisponibles"
                                            label="Seleccionar Año"
                                            @change="cargarVentasReferidos"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn
                                            color="success"
                                            @click="exportarVentasReferidos"
                                            :loading="isLoadingReferidos"
                                            class="mt-2"
                                        >
                                            <v-icon left>mdi-file-excel</v-icon>
                                            Exportar a Excel
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-icon left>mdi-table</v-icon>
                        Resumen de Ventas por Mes por Referido
                    </v-card-title>
                    <v-data-table
                        :headers="headersReferidos"
                        :items="ventasReferidos"
                        :loading="isLoadingReferidos"
                        item-key="id"
                        class="elevation-1"
                        :items-per-page="-1"
                        :search="searchReferidos"
                        hide-default-footer
                    >
                        <!-- Templates para mostrar los datos de cada mes -->
                        <template v-slot:item.mes_1="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_1 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_1 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_2="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_2 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_2 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_3="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_3 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_3 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_4="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_4 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_4 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_5="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_5 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_5 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_6="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_6 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_6 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_7="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_7 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_7 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_8="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_8 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_8 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_9="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_9 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_9 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_10="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_10 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_10 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_11="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_11 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_11 || 0 }}</span>
                        </template>
                        <template v-slot:item.mes_12="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.mes_12 || 0)
                            }}</span>
                            <span v-else>{{ item.mes_12 || 0 }}</span>
                        </template>
                        <template v-slot:item.total_anual="{ item }">
                            <span v-if="item.id === 'facturacion'">{{
                                formatPrice(item.total_anual || 0)
                            }}</span>
                            <span v-else>{{ item.total_anual || 0 }}</span>
                        </template>
                        <template v-slot:item.num_empresas="{ item }">
                            <span>{{ item.num_empresas || 0 }}</span>
                        </template>
                    </v-data-table>
                </v-card>

                <!-- Tabla de detalles por referido -->
                <v-card class="mt-4">
                    <v-card-title>
                        <v-icon left>mdi-table</v-icon>
                        Detalles de Empresas por Referido
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="referidoSeleccionado"
                                    :items="referidosDisponibles"
                                    item-text="text"
                                    item-value="value"
                                    label="Filtrar por Referido"
                                    clearable
                                    @change="cargarDetallesReferidos"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-btn
                                    color="success"
                                    @click="exportarDetallesReferidos"
                                    :loading="isLoadingDetallesReferidos"
                                    :disabled="!referidoSeleccionado"
                                    class="mt-2"
                                >
                                    <v-icon left>mdi-file-excel</v-icon>
                                    Exportar Detalles
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-data-table
                        :headers="headersDetallesReferidos"
                        :items="detallesReferidos"
                        :loading="isLoadingDetallesReferidos"
                        item-key="id"
                        class="elevation-1"
                        :items-per-page="-1"
                        :search="searchDetallesReferidos"
                        hide-default-footer
                    >
                        <!-- Templates para mostrar los datos de cada mes -->
                        <template v-slot:item.mes_1="{ item }">
                            <span>{{ formatPrice(item.mes_1 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_2="{ item }">
                            <span>{{ formatPrice(item.mes_2 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_3="{ item }">
                            <span>{{ formatPrice(item.mes_3 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_4="{ item }">
                            <span>{{ formatPrice(item.mes_4 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_5="{ item }">
                            <span>{{ formatPrice(item.mes_5 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_6="{ item }">
                            <span>{{ formatPrice(item.mes_6 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_7="{ item }">
                            <span>{{ formatPrice(item.mes_7 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_8="{ item }">
                            <span>{{ formatPrice(item.mes_8 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_9="{ item }">
                            <span>{{ formatPrice(item.mes_9 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_10="{ item }">
                            <span>{{ formatPrice(item.mes_10 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_11="{ item }">
                            <span>{{ formatPrice(item.mes_11 || 0) }}</span>
                        </template>
                        <template v-slot:item.mes_12="{ item }">
                            <span>{{ formatPrice(item.mes_12 || 0) }}</span>
                        </template>
                        <template v-slot:item.total_anual="{ item }">
                            <span>{{
                                formatPrice(item.total_anual || 0)
                            }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>
<style>
.circle {
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    display: inline-block;
}

/* Fijar primera columna */
#ventas-yotico .v-data-table__wrapper > table > thead > tr > th:first-child,
#ventas-yotico .v-data-table__wrapper > table > tbody > tr > td:first-child {
    position: sticky !important;
    left: 0;
    z-index: 2;
}

/* Header con fondo blanco y sombra */
#ventas-yotico .v-data-table__wrapper > table > thead > tr > th:first-child {
    background-color: white !important;
    z-index: 3;
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Estilos para la primera columna según el estado de la fila */
.pointer td:first-child {
    background-color: white !important;
}

.pointer:hover td:first-child {
    background-color: inherit !important;
}

.red-row td:first-child {
    background-color: inherit !important;
}

.red-row:hover td:first-child {
    background-color: inherit !important;
}

/* Resto de las columnas */
#ventas-yotico
    .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:not(:first-child),
#ventas-yotico
    .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:not(:first-child) {
    z-index: 1;
}

/* Hacer que los títulos de las columnas sean fijos */
#ventas-yotico .v-data-table__wrapper > table > thead > tr > th {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: #f5f5f5 !important;
    border-bottom: 1px solid #e0e0e0 !important;
}

/* Asegurar que el contenedor tenga scroll */
#ventas-yotico .v-data-table__wrapper {
    max-height: 70vh;
    overflow-y: auto;
}

.calculo-desglose .calculo-linea {
    font-size: 12px;
    line-height: 1.4;
}
</style>
<script>
import debounce from "lodash/debounce";
import FilterComponentVue from "../../../../components/general/FilterComponent.vue";
import { formatPrice, parseEuroNumber } from "../../../../utils/formatters";

export default {
    components: { FilterComponentVue },
    data() {
        return {
            totalItems: 0,
            search: "",
            filtros_prueba: {
                search: "",
                empresa: {},
                dia: {},
                fecha_inicio_facturacion: {},
                metodo_cobro: null,
            },
            filter_headers: [
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "cliente",
                    item_text: "nombres",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Vendedor",
                    type: "select",
                    active: false,
                    model: "vendedor",
                    item_text: "nombres",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Fecha",
                    type: "date",
                    active: true,
                    model: "dia",
                },
                {
                    title: "Fecha inicio facturación",
                    type: "date",
                    active: false,
                    model: "fecha_inicio_facturacion",
                },
                {
                    title: "Método de cobro",
                    type: "select",
                    active: false,
                    model: "metodo_cobro",
                    item_text: "label",
                    item_value: "value",
                    items: [
                        { label: "Único", value: 1 },
                        { label: "Mensual", value: 2 },
                        { label: "Plazos", value: 3 },
                        { label: "Anual", value: 4 },
                    ],
                },
            ],

            form_dialog: false,
            venta: {},
            ventas: [],
            selectedItem: {
                id: null,
                importe: 0,
                importe_calculado: 0,
                plantilla: false,
                sepa: false,
                facturado: false,
                fecha_last_factura: null,
                giro: false,
                configurado: false,
                llamada: false,
                observaciones: "",
            },

            empleados: [],
            page: 1,
            itemsPerPage: 15,
            sortBy: 'fecha_alta',
            sortDesc: true,
            importe_iva: 0,
            importe_iva_cobrado: 0,
            importe_total: 0,
            total_cobro_1: 0,
            total_cobro_2: 0,
            total_pvp: 0,

            isInvoiceDialogVisible: false,
            invoiceDate: null,
            historyItems: [],
            historyHeaders: [
                { text: "Fecha sincronización", value: "synced_at", sortable: false },
                { text: "Método de pago", value: "metodo_pago", sortable: false },
                { text: "Fecha inicio facturación", value: "fecha_inicio_facturacion", sortable: false },
                { text: "Cliente", value: "cliente_nombre", sortable: false },
                { text: "Nº usuarios", value: "num_trabajadores", sortable: false },
                { text: "Importe calculado", value: "importe_calculado", sortable: false },
                { text: "Cálculo", value: "calculo_detalle", sortable: false },
            ],
            historyTotal: 0,
            historyLoading: false,
            historyOptions: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ["synced_at"],
                sortDesc: [true],
            },
            historyDate: null,
            historyShowAll: false,
            isHistoryExporting: false,
            isExporting: false,

            // Datos para la pestaña de ventas mensuales
            isLoadingMensuales: false,
            añoSeleccionado: new Date().getFullYear(),
            añosDisponibles: [],
            ventasMensuales: [],
            detallesEmpresas: [],
            searchMensuales: "",
            searchDetalles: "",
            headersMensuales: [],
            headersDetalles: [],
            meses: [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre",
            ],
            totalPorMes: {},
            totalGeneral: 0,

            // Datos para la pestaña de ventas por referidos
            isLoadingReferidos: false,
            añoSeleccionadoReferidos: new Date().getFullYear(),
            ventasReferidos: [],
            searchReferidos: "",
            headersReferidos: [],

            // Datos para la tabla de detalles por referido
            isLoadingDetallesReferidos: false,
            referidoSeleccionado: null,
            referidosDisponibles: [],
            detallesReferidos: [],
            searchDetallesReferidos: "",
            headersDetallesReferidos: [],
        };
    },
    created() {
        this.getVentas();
        this.getEmpleados();
        this.inicializarVentasMensuales();
        this.inicializarVentasReferidos();
        this.bootstrapHistory();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (n) {
                this.getVentas();
            }, 500),
        },
    },
    methods: {
        getVentas() {
            const filtros_prueba = this.filtros_prueba;
            const self = this;

            axios
                .get(`api/get-ventas-yotico`, {
                    params: {
                        itemsPerPage: this.itemsPerPage,
                        page: this.page,
                        sort_by: this.sortBy ?? null,
                        sort_desc: this.sortDesc ?? null,
                        search: filtros_prueba.search,
                        id_cliente: filtros_prueba.cliente?.value ?? null,
                        id_vendedor: filtros_prueba.vendedor?.value ?? null,
                        fecha_inicio: filtros_prueba.dia?.start ?? null,
                        fecha_fin: filtros_prueba.dia?.end ?? null,
                        fecha_inicio_facturacion: filtros_prueba.fecha_inicio_facturacion?.start ?? null,
                        fecha_fin_facturacion: filtros_prueba.fecha_inicio_facturacion?.end ?? null,
                        tipo_proyecto: filtros_prueba.metodo_cobro?.value ?? null,
                    },
                })
                .then(
                    (res) => {
                        self.ventas = res.data.data;
                        self.totalItems = res.data.total;
                        self.total_pvp = res.data.total_pvp;
                    },
                    (err) => {
                        this.$toast.error("Error consultando Ventas");
                    }
                );
        },
        loadItems(newOptions) {
            // console.log(newOptions);
            this.page = newOptions.page;
            this.itemsPerPage = newOptions.itemsPerPage;
            this.sortBy = newOptions.sortBy && newOptions.sortBy.length > 0 ? newOptions.sortBy[0] : null;
            this.sortDesc = newOptions.sortDesc && newOptions.sortDesc.length > 0 ? newOptions.sortDesc[0] : false;
            this.getVentas();
        },
        getEmpleados() {
            axios.post(`api/get-usuarios-empleados-all`).then(
                (res) => {
                    this.empleados = res.data.users;
                    this.filter_headers[1].items = res.data.users;
                    // this.filter_headers[3].items = res.data.users;
                },
                (err) => {
                    this.$toast.error("Error consultando empleados");
                }
            );
        },

        syncDataYotico() {
            axios.get("api/sync-data-yotico").then(
                (res) => {
                    this.$toast.success(res.data.message);
                    this.getVentas();
                },
                (err) => {
                    this.$toast.error("Error sincronizando datos");
                }
            );
        },
        exportToExcel() {
            this.isExporting = true;
            const filtros_prueba = this.filtros_prueba;
            
            axios
                .get("api/export-ventas-yotico", {
                    params: {
                        search: filtros_prueba.search,
                        id_cliente: filtros_prueba.cliente?.value ?? null,
                        id_vendedor: filtros_prueba.vendedor?.value ?? null,
                        fecha_inicio: filtros_prueba.dia?.start ?? null,
                        fecha_fin: filtros_prueba.dia?.end ?? null,
                        fecha_inicio_facturacion: filtros_prueba.fecha_inicio_facturacion?.start ?? null,
                        fecha_fin_facturacion: filtros_prueba.fecha_inicio_facturacion?.end ?? null,
                        tipo_proyecto: filtros_prueba.metodo_cobro?.value ?? null,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    // Crear URL del blob
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    // Crear enlace temporal para descargar
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `ventas_yotico_${new Date().toISOString().slice(0, 10)}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Liberar la URL del blob
                    window.URL.revokeObjectURL(url);

                    this.isExporting = false;
                    this.$toast.success("Archivo descargado correctamente");
                })
                .catch((error) => {
                    this.isExporting = false;
                    this.$toast.error("Error al exportar el archivo");
                    console.error("Error:", error);
                });
        },
        onHistoryOptionsChange(newOptions) {
            const shouldFetch =
                newOptions.page !== this.historyOptions.page ||
                newOptions.itemsPerPage !== this.historyOptions.itemsPerPage;
            this.historyOptions = newOptions;
            if (shouldFetch || this.historyItems.length === 0) {
                this.fetchSyncHistory();
            }
        },
        async fetchSyncHistory(skipEnsure = false) {
            if (!skipEnsure) {
                await this.ensureHistoryDate();
            }
            if (!this.historyDate) {
                return;
            }
            this.historyLoading = true;
            const fecha = this.historyDate;
            axios
                .get("api/ventas-yotico/sync-history", {
                    params: {
                        page: this.historyOptions.page,
                        per_page: this.historyOptions.itemsPerPage,
                        fecha_inicio: fecha,
                        fecha_fin: fecha,
                        mostrar_todos: this.historyShowAll ? 1 : 0,
                    },
                })
                .then((res) => {
                    const response = res.data || {};
                    const registros = response.data || [];
                    this.historyItems = registros.map((log) =>
                        this.mapHistoryRecord(log)
                    );
                    this.historyTotal = response.total || 0;
                    if (this.historyShowAll) {
                        const itemsPerPage =
                            this.historyTotal ||
                            registros.length ||
                            this.historyOptions.itemsPerPage;
                        this.historyOptions = {
                            ...this.historyOptions,
                            page: 1,
                            itemsPerPage,
                        };
                    }
                })
                .catch(() => {
                    this.$toast.error("Error cargando el historial");
                })
                .finally(() => {
                    this.historyLoading = false;
                });
        },
        saveCaracteristicasVentaYotico(item) {
            const data = Object.fromEntries(
                Object.entries(item).filter(
                    ([key]) =>
                        key !== "nombre" &&
                        key !== "nombre_empresa" &&
                        key !== "nombre_cliente" &&
                        key !== "num_trabajadores" &&
                        key !== "fecha_alta"
                )
            );
            axios
                .post("api/save-caracteristicas-venta-yotico", data)
                .then((res) => {
                    this.$toast.success(res.data.message);
                    this.getVentas();
                })
                .catch((err) => {
                    this.$toast.error("Error guardando características");
                });
        },
        openInvoiceDialog() {
            this.isInvoiceDialogVisible = true;
        },
        closeInvoiceDialog() {
            this.isInvoiceDialogVisible = false;
        },
        generateInvoices() {
            axios
                .get("api/generate-invoices", {
                    params: {
                        fecha: this.invoiceDate,
                        itemsPerPage: -1,
                    },
                })
                .then((res) => {
                    this.$toast.success(res.data.message);
                    this.closeInvoiceDialog();
                    this.getVentas();
                });
        },
        ensureHistoryDate() {
            if (this.historyDate) {
                return Promise.resolve();
            }
            return axios
                .get("api/ventas-yotico/sync-history", {
                    params: {
                        page: 1,
                        per_page: 1,
                    },
                })
                .then((res) => {
                    const registros = res.data?.data || [];
                    if (registros.length > 0 && registros[0].synced_at) {
                        this.historyDate = registros[0].synced_at.slice(0, 10);
                    } else {
                        this.historyDate = new Date().toISOString().slice(0, 10);
                    }
                })
                .catch(() => {
                    this.historyDate = new Date().toISOString().slice(0, 10);
                });
        },
        onHistoryDateChange(value) {
            if (!value) {
                this.historyDate = null;
                this.bootstrapHistory();
                return;
            }
            this.historyOptions.page = 1;
            this.historyDate = value;
            this.fetchSyncHistory(true);
        },
        onHistoryShowAllChange() {
            const itemsPerPage = this.historyShowAll
                ? this.historyTotal || this.historyOptions.itemsPerPage || 10
                : 10;
            this.historyOptions = {
                ...this.historyOptions,
                page: 1,
                itemsPerPage,
            };
            this.fetchSyncHistory(true);
        },
        async bootstrapHistory() {
            await this.ensureHistoryDate();
            this.fetchSyncHistory(true);
        },
        formatDateTime(value) {
            if (!value) {
                return "-";
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })}`;
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            return date.toLocaleDateString();
        },
        formatCalculationLines(detalle) {
            if (!Array.isArray(detalle) || detalle.length === 0) {
                return [];
            }
            return detalle.map((item) => this.formatCalculationLine(item));
        },
        formatCalculationLine(item) {
            if (!item) {
                return "";
            }
            const descripcion = item.descripcion || "Tarifa";
            const tipo = item.tipo === "fijo" ? "fijo" : "variable";
            const origen =
                item.origen === "rango" ? "rango automático" : "seleccionada";
            const unitario = this.formatPrice(item.precio_unitario || 0);
            const total = this.formatPrice(item.importe || 0);
            if (tipo === "fijo") {
                return `${descripcion} (${tipo}, ${origen}) → ${unitario} €`;
            }
            const cantidad = Number(item.cantidad || 0);
            return `${descripcion} (${tipo}, ${origen}) : ${unitario} € × ${cantidad} = ${total} €`;
        },
        formatPrice,
        getMetodoPagoNombre(tipoProyecto) {
            const tipoNum = Number(tipoProyecto);
            switch (tipoNum) {
                case 1:
                    return "Único";
                case 2:
                    return "Mensual";
                case 3:
                    return "Plazos";
                case 4:
                    return "Anual";
                default:
                    return "-";
            }
        },
        mapHistoryRecord(log) {
            const proyecto = log.proyecto || {};
            const cliente = proyecto.usuario || {};
            return {
                ...log,
                proyecto_id: log.proyecto_id || proyecto.id || null,
                proyecto_nombre: proyecto.nombre || "",
                cliente_nombre:
                    cliente.nombre_comercial ||
                    cliente.nombre_fiscal ||
                    cliente.nombre ||
                    "",
                metodo_pago: this.getMetodoPagoNombre(proyecto.tipo_proyecto),
                fecha_inicio_facturacion: proyecto.fecha_inicio_facturacion || null,
                calculo_detalle: this.formatCalculationLines(log.detalle_calculo),
            };
        },
        deduplicateHistoryRecords(records) {
            const map = new Map();
            records.forEach((record) => {
                const key =
                    record.proyecto_id ||
                    (record.proyecto && record.proyecto.id) ||
                    record.id;
                if (!key) {
                    return;
                }
                const existing = map.get(key);
                if (
                    !existing ||
                    new Date(record.synced_at) > new Date(existing.synced_at)
                ) {
                    map.set(key, record);
                }
            });
            return Array.from(map.values());
        },
        convertCalculationLinesToString(detalle) {
            const lines = Array.isArray(detalle)
                ? detalle
                : this.formatCalculationLines(detalle);
            return lines.join(" | ");
        },
        convertHistoryToCsv(records) {
            const headers = [
                "Proyecto",
                "Cliente",
                "Método de Pago",
                "Fecha Inicio Facturación",
                "Fecha Sincronización",
                "Nº Usuarios",
                "Importe Calculado (€)",
                "Detalle Cálculo",
            ];

            const lines = [headers.join(";")];
            records.forEach((record) => {
                const row = [
                    record.proyecto_nombre || "",
                    record.cliente_nombre || "",
                    record.metodo_pago || "",
                    this.formatDate(record.fecha_inicio_facturacion),
                    this.formatDateTime(record.synced_at),
                    record.num_trabajadores ?? "",
                    this.formatPrice(record.importe_calculado || 0),
                    this.convertCalculationLinesToString(record.calculo_detalle),
                ];
                lines.push(row.map((value) => this.escapeCsvValue(value)).join(";"));
            });

            return lines.join("\n");
        },
        escapeCsvValue(value) {
            if (value === null || value === undefined) {
                return "";
            }
            const stringValue = String(value).replace(/"/g, '""');
            if (/[",;\n]/.test(stringValue)) {
                return `"${stringValue}"`;
            }
            return stringValue;
        },
        downloadCsv(content, filename) {
            const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        async exportHistory() {
            try {
                this.isHistoryExporting = true;
                await this.ensureHistoryDate();
                if (!this.historyDate) {
                    this.$toast.error("Selecciona una fecha para exportar");
                    return;
                }
                const response = await axios.get("api/ventas-yotico/sync-history", {
                    params: {
                        page: 1,
                        per_page: 10000,
                        fecha_inicio: this.historyDate,
                        fecha_fin: this.historyDate,
                        mostrar_todos: this.historyShowAll ? 1 : 0,
                    },
                });
                let registros = response.data?.data || [];
                if (!Array.isArray(registros) || registros.length === 0) {
                    this.$toast.error("No hay registros para exportar");
                    return;
                }
                registros = registros.map((log) => this.mapHistoryRecord(log));
                const deduplicated = this.deduplicateHistoryRecords(registros);
                const csvContent = this.convertHistoryToCsv(deduplicated);
                const filename = `historial_yotico_${this.historyDate.replace(
                    /-/g,
                    ""
                )}.csv`;
                this.downloadCsv(csvContent, filename);
            } catch (error) {
                console.error(error);
                this.$toast.error("Error exportando historial");
            } finally {
                this.isHistoryExporting = false;
            }
        },
        row_classes(item) {
            if (this.user.role != 11) {
                if (item.desestimar) {
                    return "red-row pointer";
                } else {
                    return "pointer";
                }
            } else {
                return "pointer";
            }
        },

        // Métodos para ventas mensuales
        inicializarVentasMensuales() {
            this.generarAñosDisponibles();
            this.generarHeadersMensuales();
            this.generarHeadersDetalles();
            this.cargarVentasMensuales();
        },

        inicializarVentasReferidos() {
            this.generarHeadersReferidos();
            this.generarHeadersDetallesReferidos();
            this.cargarVentasReferidos();
        },

        generarAñosDisponibles() {
            const añoActual = new Date().getFullYear();
            const años = [];
            for (let i = añoActual - 5; i <= añoActual + 1; i++) {
                años.push(i);
            }
            this.añosDisponibles = años;
        },

        generarHeadersMensuales() {
            const headers = [
                {
                    text: "Concepto",
                    value: "concepto",
                    sortable: false,
                    width: "200px",
                },
            ];

            // Agregar columnas para cada mes
            this.meses.forEach((mes, index) => {
                headers.push({
                    text: mes.charAt(0).toUpperCase() + mes.slice(1),
                    value: `mes_${index + 1}`,
                    sortable: false,
                    align: "center",
                    width: "120px",
                });
            });

            // Agregar columna de total anual
            headers.push({
                text: "Total Anual",
                value: "total_anual",
                sortable: false,
                align: "center",
                width: "150px",
            });

            this.headersMensuales = headers;
        },

        generarHeadersDetalles() {
            const headers = [
                {
                    text: "Empresa",
                    value: "nombre_empresa",
                    sortable: false,
                    width: "250px",
                },
                {
                    text: "Trabajadores",
                    value: "num_trabajadores",
                    sortable: false,
                    align: "center",
                    width: "100px",
                },
                {
                    text: "Fecha Alta",
                    value: "fecha_alta",
                    sortable: false,
                    width: "120px",
                },
            ];

            // Agregar columnas para cada mes
            this.meses.forEach((mes, index) => {
                headers.push({
                    text: mes.charAt(0).toUpperCase() + mes.slice(1),
                    value: `mes_${index + 1}`,
                    sortable: false,
                    align: "center",
                    width: "120px",
                });
            });

            // Agregar columna de total anual
            headers.push({
                text: "Total Anual",
                value: "total_anual",
                sortable: false,
                align: "center",
                width: "150px",
            });

            this.headersDetalles = headers;
        },

        generarHeadersReferidos() {
            const headers = [
                {
                    text: "Referido",
                    value: "concepto",
                    sortable: false,
                    width: "250px",
                },
                {
                    text: "Número Empresas",
                    value: "num_empresas",
                    sortable: false,
                    align: "center",
                    width: "150px",
                },
            ];

            // Agregar columnas para cada mes
            this.meses.forEach((mes, index) => {
                headers.push({
                    text: mes.charAt(0).toUpperCase() + mes.slice(1),
                    value: `mes_${index + 1}`,
                    sortable: false,
                    align: "center",
                    width: "120px",
                });
            });

            // Agregar columna de total anual
            headers.push({
                text: "Total Anual",
                value: "total_anual",
                sortable: false,
                align: "center",
                width: "150px",
            });

            this.headersReferidos = headers;
        },

        generarHeadersDetallesReferidos() {
            const headers = [
                {
                    text: "Empresa",
                    value: "nombre_empresa",
                    sortable: false,
                    width: "250px",
                },
                {
                    text: "Trabajadores",
                    value: "num_trabajadores",
                    sortable: false,
                    align: "center",
                    width: "100px",
                },
                {
                    text: "Fecha Alta",
                    value: "fecha_alta",
                    sortable: false,
                    width: "120px",
                },
            ];

            // Agregar columnas para cada mes
            this.meses.forEach((mes, index) => {
                headers.push({
                    text: mes.charAt(0).toUpperCase() + mes.slice(1),
                    value: `mes_${index + 1}`,
                    sortable: false,
                    align: "center",
                    width: "120px",
                });
            });

            // Agregar columna de total anual
            headers.push({
                text: "Total Anual",
                value: "total_anual",
                sortable: false,
                align: "center",
                width: "150px",
            });

            this.headersDetallesReferidos = headers;
        },

        cargarVentasMensuales() {
            this.isLoadingMensuales = true;
            console.log(
                "Cargando ventas mensuales para el año:",
                this.añoSeleccionado
            );

            axios
                .get("api/get-ventas-mensuales-yotico", {
                    params: {
                        año: this.añoSeleccionado,
                    },
                })
                .then((response) => {
                    console.log(
                        "Respuesta de ventas mensuales:",
                        response.data
                    );
                    this.ventasMensuales = response.data.data;
                    this.detallesEmpresas = response.data.detalles || [];
                    this.totalPorMes = response.data.total_por_mes;
                    this.totalGeneral = response.data.total_general;
                    this.isLoadingMensuales = false;
                    console.log(
                        "Ventas mensuales cargadas:",
                        this.ventasMensuales.length,
                        "conceptos"
                    );
                    console.log(
                        "Detalles cargados:",
                        this.detallesEmpresas.length,
                        "empresas"
                    );
                })
                .catch((error) => {
                    this.$toast.error("Error cargando ventas mensuales");
                    this.isLoadingMensuales = false;
                    console.error("Error:", error);
                });
        },

        exportarVentasMensuales() {
            this.isLoadingMensuales = true;

            axios
                .get("api/export-ventas-mensuales-yotico", {
                    params: {
                        año: this.añoSeleccionado,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    // Crear URL del blob
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    // Crear enlace temporal para descargar
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `ventas_mensuales_yotico_${
                        this.añoSeleccionado
                    }_${new Date().toISOString().slice(0, 10)}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Liberar la URL del blob
                    window.URL.revokeObjectURL(url);

                    this.isLoadingMensuales = false;
                    this.$toast.success("Archivo descargado correctamente");
                })
                .catch((error) => {
                    this.isLoadingMensuales = false;
                    this.$toast.error("Error al exportar el archivo");
                    console.error("Error:", error);
                });
        },

        // Métodos para la pestaña de ventas por referidos
        cargarVentasReferidos() {
            this.isLoadingReferidos = true;
            console.log(
                "Cargando ventas por referidos para el año:",
                this.añoSeleccionadoReferidos
            );

            axios
                .get("api/get-ventas-referidos-yotico", {
                    params: {
                        año: this.añoSeleccionadoReferidos,
                    },
                })
                .then((response) => {
                    console.log(
                        "Respuesta de ventas por referidos:",
                        response.data
                    );
                    this.ventasReferidos = response.data.data;
                    this.isLoadingReferidos = false;
                    console.log(
                        "Ventas por referidos cargadas:",
                        this.ventasReferidos.length,
                        "referidos"
                    );

                    // Generar lista de referidos disponibles para el filtro
                    this.referidosDisponibles = this.ventasReferidos
                        .filter((item) => item.id !== "facturacion")
                        .map((item) => ({
                            text: item.concepto,
                            value: item.id,
                        }));

                    // Debug temporal
                    if (response.data.debug) {
                        console.log("=== DEBUG VENTAS REFERIDOS ===");
                        console.log(
                            "Total empresas encontradas:",
                            response.data.debug.total_empresas_encontradas
                        );
                        console.log(
                            "Empresas con referido:",
                            response.data.debug.empresas_con_referido
                        );
                        console.log(
                            "Detalle de empresas:",
                            response.data.debug.empresas_detalle
                        );
                        console.log("==============================");
                    }
                })
                .catch((error) => {
                    this.$toast.error("Error cargando ventas por referidos");
                    this.isLoadingReferidos = false;
                    console.error("Error:", error);
                });
        },

        exportarVentasReferidos() {
            this.isLoadingReferidos = true;

            axios
                .get("api/export-ventas-referidos-yotico", {
                    params: {
                        año: this.añoSeleccionadoReferidos,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    // Crear URL del blob
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    // Crear enlace temporal para descargar
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `ventas_referidos_yotico_${
                        this.añoSeleccionadoReferidos
                    }_${new Date().toISOString().slice(0, 10)}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Liberar la URL del blob
                    window.URL.revokeObjectURL(url);

                    this.isLoadingReferidos = false;
                    this.$toast.success("Archivo descargado correctamente");
                })
                .catch((error) => {
                    this.isLoadingReferidos = false;
                    this.$toast.error("Error al exportar el archivo");
                    console.error("Error:", error);
                });
        },

        // Métodos para la tabla de detalles por referido
        cargarDetallesReferidos() {
            if (!this.referidoSeleccionado) {
                this.detallesReferidos = [];
                return;
            }

            this.isLoadingDetallesReferidos = true;

            axios
                .get("api/get-detalles-referidos-yotico", {
                    params: {
                        año: this.añoSeleccionadoReferidos,
                        referido_id: this.referidoSeleccionado,
                    },
                })
                .then((response) => {
                    console.log(
                        "Respuesta de detalles por referido:",
                        response.data
                    );
                    this.detallesReferidos = response.data.data;
                    this.isLoadingDetallesReferidos = false;
                })
                .catch((error) => {
                    this.$toast.error("Error cargando detalles por referido");
                    this.isLoadingDetallesReferidos = false;
                    console.error("Error:", error);
                });
        },

        exportarDetallesReferidos() {
            if (!this.referidoSeleccionado) {
                this.$toast.error("Debe seleccionar un referido para exportar");
                return;
            }

            this.isLoadingDetallesReferidos = true;

            axios
                .get("api/export-detalles-referidos-yotico", {
                    params: {
                        año: this.añoSeleccionadoReferidos,
                        referido_id: this.referidoSeleccionado,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    // Crear URL del blob
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    // Crear enlace temporal para descargar
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `detalles_referido_${
                        this.referidoSeleccionado
                    }_${this.añoSeleccionadoReferidos}_${new Date()
                        .toISOString()
                        .slice(0, 10)}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Liberar la URL del blob
                    window.URL.revokeObjectURL(url);

                    this.isLoadingDetallesReferidos = false;
                    this.$toast.success("Archivo descargado correctamente");
                })
                .catch((error) => {
                    this.isLoadingDetallesReferidos = false;
                    this.$toast.error("Error al exportar el archivo");
                    console.error("Error:", error);
                });
        },
    },
    computed: {
        user() {
            return this.$store.getters.getuser;
        },
        headers() {
            return [
                {
                    text: "Nombre de la empresa",
                    value: "nombre_empresa",
                    sortable: false,
                },
                { text: "Fecha de alta", value: "fecha_alta", sortable: false },
                {
                    text: "Num. Trabajadores",
                    value: "num_trabajadores",
                    sortable: false,
                    align: "center",
                },
                { text: "Precio Proyecto", value: "importe", sortable: false },
                {
                    text: "Importe Periódico",
                    value: "importe_calculado",
                    sortable: false,
                },
                {
                    text: "Fecha inicio facturación",
                    value: "fecha_inicio_facturacion",
                    sortable: false,
                },
                {
                    text: "Método de pago",
                    value: "metodo_pago",
                    sortable: false,
                },
                {
                    text: "Plantilla",
                    value: "plantilla",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "Configurado",
                    value: "configurado",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "Observaciones",
                    value: "observaciones",
                    sortable: false,
                },
                /*{ text: "Acciones", value: "action", sortable: false }, */
            ];
        },
        isLoading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
